import { Button, Box, Input, IconButton } from "@chakra-ui/react";
import { Field, FieldArray, Form, Formik } from "formik";
import React from 'react';
import { Flex } from '@chakra-ui/react';
import { CloseIcon, AddIcon } from "@chakra-ui/icons";
import { compose as C, map as m, partition, prop as p, path } from "ramda";
import { useUpdateDecisionMutation, useUpsertDataMutation, useDeleteDataMutation } from "../app/api";
import { useSelector } from "react-redux";

export const MultipleInput = ({ filtered, decision_id, activity_id, participant_id, order_nr,
  next_to_show,show_until, is_last, all_done }) => {
  const [upsertData] = useUpsertDataMutation();
  const [deleteData] = useDeleteDataMutation();
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));

  const handleSubmit = C(
    upsertData,
    m(m(({ value_text, id }) => ({
      value_text,
      ...(id ? { id } : {}),
      decision_id,
      participant_id,
      activity_id
    }))),
    partition(p("id")),
    p("inputs")
  );

  return (
    <Box>
      <Formik
        enableReinitialize={true}
        initialValues={{ inputs: filtered.length ? filtered : [{ value_text: "" }] }}
        onSubmit={handleSubmit}
      >
        {({ values, dirty }) => (
          <Form>
            <FieldArray name="inputs">
              {({ push, remove }) => (
                <>
                  {values.inputs.map((input, index) => (
                    <Flex gap={2} key={index} alignItems={"center"}>
                      <Field as={Input} name={`inputs.${index}.value_text`} autoComplete="off" />
                      <IconButton
                        icon={<CloseIcon />}
                        colorScheme="teal"
                        ml={5}
                        size="xs"
                        onClick={() => {
                          deleteData(input.id);
                          remove(index);
                        }}
                      />
                    </Flex>
                  ))}
                  <Flex gap={2} mt={2}>
                    <IconButton
                      type="button"
                      icon={<AddIcon />}
                      size="md"
                      colorScheme="teal"
                      onClick={() => push({ value_text: "" })}
                    >
                      {texts.add_row}
                    </IconButton>
                    <Button
                      size="md"
                      colorScheme="teal"
                      type="submit"
                      isDisabled={!dirty} // "Salvesta" button enabled only when inputs have changed
                    >
                      {texts.save}
                    </Button>
                    {(is_last || (show_until > order_nr) || !all_done) ? null : (
                      <Button
                        size="md"
                        colorScheme="blue"
                        onClick={() => {
                          moveForward({
                            id: decision_id,
                            done: order_nr,
                            show_until:next_to_show
                          });
                        }}
                      >
                        {texts.next}
                      </Button>
                    )}
                  </Flex>
                </>
              )}
            </FieldArray>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
